import {Provider} from '@angular/core';

import {ListPersonTypesUseCase} from '@features/setting/application/use_cases/list-person-types/list-person-types.use-case';

import {
  ListPersonTypesHttpProvider
} from '@features/setting/infrastructure/http/list-person-types/list-person-types.http.provider';

export const ListPersonTypesUseCaseProvider: Provider[] = [
  ...ListPersonTypesHttpProvider,
  ListPersonTypesUseCase
];
